import { initializeFaro } from '@grafana/faro-web-sdk';

export const faro = initializeFaro({
  url: '/faro-collect',

  app: {
    name: 'frontend',
  },
});
